<template>
  <v-popover
    ref="popOverRef"
    openClass="keyword-list-explanation--active"
    class="keyword-list-explanation"
    placement="top-end"
    delay="200"
    :autoHide="true"
    popoverClass="keyword-list-explanation__explanation"
  >
    <BaseRoundButton
      class="keyword-list-explanation__button"
      @click.native="explanationClick"
      :icon="isActive ? 'x' : 'help'"
      is-dark
      is-floating
      :size="32"
    />

    <template slot="popover">
      <div class="explanation__explanation-title">{{ $t('page.keywords.explanation.title') }}</div>
      <div class="explanation__explanation-description">
        <div class="explanation-description__explanation-item">
          <p class="explanation-item__symbol">{{ $t('page.keywords.explanation.asterisk.symbol') }}</p>
          <p class="explanation-item__rule">
            {{ $t('page.keywords.explanation.asterisk.rule') }}
          </p>
          <p class="explanation-item__example" v-html="$t('page.keywords.explanation.asterisk.example')"></p>
        </div>

        <div class="explanation-description__explanation-item">
          <p class="explanation-item__symbol">{{ $t('page.keywords.explanation.tilde.symbol') }}</p>
          <p class="explanation-item__rule">
            {{ $t('page.keywords.explanation.tilde.rule') }}
          </p>
          <p class="explanation-item__example" v-html="$t('page.keywords.explanation.tilde.example')"></p>
        </div>

        <div class="explanation-description__explanation-item">
          <p class="explanation-item__symbol">{{ $t('page.keywords.explanation.brackets.symbol') }}</p>
          <p class="explanation-item__rule">
            {{ $t('page.keywords.explanation.brackets.rule') }}
          </p>
          <p class="explanation-item__example" v-html="$t('page.keywords.explanation.brackets.example')"></p>
        </div>

        <div class="explanation-description__explanation-item">
          <p class="explanation-item__symbol ignored">{{ $t('page.keywords.explanation.exclamation.symbol') }}</p>
          <p class="explanation-item__rule">
            {{ $t('page.keywords.explanation.exclamation.rule') }}
          </p>
          <p class="explanation-item__example" v-html="$t('page.keywords.explanation.exclamation.example')"></p>
        </div>

        <div class="explanation-description__explanation-help">
          {{ $t('page.keywords.explanation.help') }}
        </div>
      </div>
    </template>
  </v-popover>
</template>

<script>
import BaseRoundButton from '@/components/base/BaseRoundButton';

export default {
  name: 'KeywordExplanation',
  components: {
    BaseRoundButton,
  },
  data() {
    return {
      isInit: Boolean,
    };
  },
  computed: {
    isActive() {
      return this.isInit && this.$refs.popOverRef && this.$refs.popOverRef.isOpen;
    },
  },
  methods: {
    explanationClick() {
      this.$track.keywordsExplanation();
    },
  },
  mounted() {
    this.isInit = !!this.$refs.popOverRef;
  },
};
</script>

<style lang="scss">
.keywords__explanation {
  margin-top: -2px;
}
.keyword-list-explanation {
  &__explanation {
    box-shadow: $shadow-center;
    padding: 0.5rem 1rem 1rem;
    max-width: 391px;

    // Phones: within the screen, its gutter on each side.
    @include screen-below('tablet') {
      max-width: calc(100vw - #{2 * $phone-page-gutter});
    }
  }
}

.explanation {
  &__explanation-title {
    font-family: $font-family-raleway;
    font-size: $font-size-xbigger;
    font-weight: bold;
    line-height: 1.9;
    color: $color-normal;
    margin-bottom: 0.2rem;
  }

  &__explanation-description {
    font-family: $font-families;
    font-size: $font-size-xsmall;
    color: $color-normal;
    line-height: 1.5;
  }
}

.explanation-description {
  &__explanation-item {
    padding-bottom: 0.2rem;

    p {
      margin: 0;
      padding-bottom: 0.3rem;
    }
  }

  &__explanation-help {
    padding-top: 0.5rem;
  }
}

.explanation-item {
  &__symbol {
    font-size: $font-size-bigger;
    color: $color-accent-2;
    line-height: $font-size-bigger;
  }

  &__rule {
    font-size: $font-size-xsmall;
    line-height: $font-size-bigger;
  }

  &__example {
    font-size: $font-size-xsmall;
    line-height: $font-size-bigger;
    color: $color-normal-pale;
    font-style: italic;

    span {
      font-weight: bold;

      &.symbol {
        color: $color-accent-2;
      }
    }
  }
}

.ignored {
  color: $color-error;
}
</style>
